<template>
  <div class="grid-view">
    <div v-show="view==='list'" class="main-content">
      <search-item
        ref="searchItem"
        config-module="19212"
        :expand-adv="true"
        :show-simple="false"
        @advSearchItemCallBack="queryHandler"
      >
        <div slot="operations">
          <el-button type="success" :disabled="!selectedRow" @click="detail">{{ $t('CargoMsg.Cargo_View') }}</el-button>
          <el-button no="print" type="success" @click="toPrint">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
          <el-button v-if="editShow" type="primary" no="Edit" @click="edit">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
          <el-button v-if="cancelCarFormShow" type="danger" no="Edit" @click="cancelCarForm">{{ $t('CargoMsg.Cargo_CancelVehicleOrder') }}</el-button>
          <el-button v-if="sentCarFormShow" type="primary" no="Edit" @click="showActionDialog(SystemConstants.CAR_FORM_ACTION_SENT.code)">{{ $t('CargoMsg.Cargo_VehicleDispatched') }}</el-button>
          <el-button v-if="revokeSentCarStatusShow" type="primary" no="Edit" @click="showActionDialog(SystemConstants.CAR_FORM_ACTION_REVOKE_SENT.code)">{{ $t('CargoMsg.Cargo_CancelVehicleStatus') }}</el-button>
          <el-button v-if="finishedShow" type="primary" no="Edit" @click="showActionDialog(SystemConstants.CAR_FORM_ACTION_FINISHED.code)">{{ $t('CargoMsg.Cargo_Completed1') }}</el-button>
          <el-button v-if="revokeFinishedStatusShow" type="primary" no="Edit" @click="showActionDialog(SystemConstants.CAR_FORM_ACTION_REVOKE_FINISHED.code)">{{ $t('CargoMsg.Cargo_CancelCompletedStatus') }}</el-button>
          <el-button type="primary" no="Edit" @click="statusUpdateRecordClick">{{ $t('CargoMsg.Cargo_StatusUpdateRecord') }}</el-button>
        </div>
      </search-item>
      <div style="flex-grow: 1;min-height: 350px;">
        <cargo-ag-grid-wrapper
          config-module="202506074"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :show-selected-color="false"
          :check-sub-record="false"
          style="height: 100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="202506074"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="fetchDataByPage"
        />
      </div>
    </div>
    <!--车单 状态更新记录 弹窗-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="recordDialog.visible"
      :title="$t('CargoMsg.Cargo_StatusUpdateRecord')"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="recordDialog.gridOptions"
          :column-defs="recordDialog.columnDefs"
          :row-data="recordDialog.rowData"
          style="width:100%;height: 300px"
        />
      </div>
      <span slot="footer">
        <el-button no="close" @click="recordDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!--车单 按钮操作状态 弹窗-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="actionDialog.visible"
      :title="$t('CargoMsg.Cargo_UpdateVehicleOrderStatus')"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <!--状态-->
          <el-form-item
            v-if="[SystemConstants.CAR_FORM_ACTION_REVOKE_SENT.code, SystemConstants.CAR_FORM_ACTION_REVOKE_FINISHED.code].indexOf(actionDialog.action) > -1"
            :label="$t('CargoMsg.Cargo_Status')"
          >
            <el-select v-model="actionDialog.status" no="status" disabled>
              <el-option
                v-for="item in SystemConstants.CAR_FORM_STATUS"
                :key="item.code"
                :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <!--出车时间-->
          <el-form-item
            v-if="SystemConstants.CAR_FORM_ACTION_SENT.code === actionDialog.action ||
              (SystemConstants.CAR_FORM_ACTION_FINISHED.code === actionDialog.action
              && selectedRows && selectedRows.length > 0 && selectedRows[0].status === SystemConstants.CAR_FORM_STATUS_NOT_SENT.code)"
            :label="$t('CargoMsg.Cargo_VehicleTime')"
            required
          >
            <el-date-picker
              v-model="actionDialog.departureDate"
              no="departureDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              style="width: 100%"
            />
          </el-form-item>
          <!--完成时间-->
          <el-form-item
            v-if="SystemConstants.CAR_FORM_ACTION_FINISHED.code === actionDialog.action"
            :label="$t('CargoMsg.Cargo_CompletionTime')"
            required
          >
            <el-date-picker
              v-model="actionDialog.finishedDate"
              no="finishedDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              style="width: 100%"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="confirm" type="primary" @click="editStatus">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="cancel" @click="actionDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!--车单详情-->
    <car-form-tab-detail
      v-if="view==='detail'"
      ref="carFormTabDetail"
      :lob="lob"
      source="CarFormTab"
      @back="back"
    />
    <!--车单 打印 弹窗-->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInputNumber from '@/components/Cargo/Common/cargoInputNumber'
import cargoNumericStepper from '@/components/Cargo/Common/cargoNumericStepper'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import CarFormTabDetail from '@/components/Cargo/CarForm/carFormTabDetail'
import {
  cancelCarForm,
  editCarFormStatus,
  queryCarForm,
  queryStatusRecords
} from '@/api/booking/carForm'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import moment from 'moment'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { CAR_FORM_ACTION_FINISHED, CAR_FORM_ACTION_SENT } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'CarFormTab',
  components: {
    CarFormTabDetail, cargoAgGridWrapper, searchItem, CargoButtonGroupSlider, cargoAdvanceSelect, cargoInputNumber,
    cargoNumericStepper, cargoTemplateSelectorDialog },
  props: {
    lob: { type: String, default: '' }
  },
  data() {
    return {
      SystemConstants,
      loading: false,
      isAdvancedQuery: false, // 是否为高级查询
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        context: {
          componentParent: this
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        },
        // 行点击触发事件
        onRowClicked: this.onRowClickedHandler,
        onRowDoubleClicked: this.onRowDoubleClickedHandler
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VehicleOrderNo'),
          field: 'carFormNo',
          colId: 'carFormNo',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Motorcade'),
          field: 'carryingCmp',
          colId: 'carryingCmp',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.TruckNo'),
          colId: 'plateNumber',
          field: 'plateNumber',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.Driver'),
          field: 'driverName',
          colId: 'driverName',
          width: 120
        },
        {
          headerName: this.$t('Warehouse.DriverPhone'),
          field: 'driverPhone',
          colId: 'driverPhone',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.DriverIDCard'),
          field: 'driverIdCard',
          colId: 'driverIdCard',
          width: 300
        }, {
          headerName: this.$t('CargoMsg.Cargo_VehicleTime'),
          field: 'departureDate',
          colId: 'departureDate',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CompletionTime'),
          field: 'finishedDate',
          colId: 'finishedDate',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Destination'),
          field: 'destination',
          colId: 'destination',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Status'),
          field: 'status',
          colId: 'status',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.CAR_FORM_STATUS)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          colId: 'remarks',
          width: 150
        }
      ],
      rowData: [],
      selectedRows: [],
      selectedRow: null,
      gridApi: null,
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      view: 'list',
      actionDialog: {
        visible: false,
        action: null,
        status: null,
        departureDate: null,
        finishedDate: null,
        carFormUuids: []
      },
      recordDialog: {
        visible: false,
        gridOptions: {},
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_ModificationTime'),
            field: 'dateModified',
            colId: 'dateModified',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Modifier'),
            field: 'modifiedBy',
            colId: 'modifiedBy',
            width: 130,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ModifyContent'),
            field: 'type',
            colId: 'type',
            width: 200,
            cellRenderer: (params) => {
              return this.$t('CargoMsg.Cargo_StateUpdate') + ':' + ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.CAR_FORM_RECORD_STATUS)
            }
          }
        ],
        rowData: []
      },
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'CAR_FORM_LIST',
        data: {
          CAR_FORM_UUID_LIST: []
        }
      }
    }
  },
  computed: {
    // 编辑 权限
    editShow() {
      let show = false
      switch (this.lob) {
        case 'AE':
          show = this.$checkPermission(['button_UseCarApplicationFormTabAE_Edit'])
          break
        default:
      }
      return show
    },
    // 取消车单 权限
    cancelCarFormShow() {
      let show = false
      switch (this.lob) {
        case 'AE':
          show = this.$checkPermission(['button_CarFormTabAE_CancelCarForm'])
          break
        default:
      }
      return show
    },
    // 已出车 权限
    sentCarFormShow() {
      let show = false
      switch (this.lob) {
        case 'AE':
          show = this.$checkPermission(['button_CarFormTabAE_SentCarForm'])
          break
        default:
      }
      return show
    },
    // 撤销出车状态 权限
    revokeSentCarStatusShow() {
      let show = false
      switch (this.lob) {
        case 'AE':
          show = this.$checkPermission(['button_CarFormTabAE_RevokeSentCarStatus'])
          break
        default:
      }
      return show
    },
    // 已完成 权限
    finishedShow() {
      let show = false
      switch (this.lob) {
        case 'AE':
          show = this.$checkPermission(['button_CarFormTabAE_Finished'])
          break
        default:
      }
      return show
    },
    // 撤销完成状态 权限
    revokeFinishedStatusShow() {
      let show = false
      switch (this.lob) {
        case 'AE':
          show = this.$checkPermission(['button_CarFormTabAE_RevokeFinishedStatus'])
          break
        default:
      }
      return show
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      async handler() {
        this.queryHandler()
      }
    }
  },
  created() {
  },
  methods: {
    // 打印按钮触发事件
    toPrint() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      if (this.selectedRows.length > 1) {
        this.$message.warning(this.$t('Clearing.PleaseSelectOnlyOneRecord'))
        return
      }
      this.templateSelectorDialog.data.CAR_FORM_UUID_LIST = [this.selectedRows[0].uuid]
      this.templateSelectorDialog.visible = true
    },
    init() {
      if (this.view === 'list') {
        this.queryHandler()
      }
    },
    // 状态更新记录点击
    statusUpdateRecordClick() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectAPieceOfData'))
        return
      }
      this.loading = getLoading4Cxt()
      queryStatusRecords({ uuid: this.selectedRow.uuid }).then(res => {
        this.recordDialog.rowData = res.data
        this.recordDialog.visible = true
        this.selectedRow = null
      }).finally(() => {
        this.loading.close()
      })
    },
    // 编辑 状态
    editStatus() {
      if (this.actionDialog.action === SystemConstants.CAR_FORM_ACTION_SENT.code) {
        if (!this.actionDialog.departureDate) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_VehicleTime'))
          return
        }
      }
      if (this.actionDialog.action === SystemConstants.CAR_FORM_ACTION_FINISHED.code) {
        if (!this.actionDialog.finishedDate) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_CompletionTime'))
          return
        }
        if (this.selectedRows[0].status === SystemConstants.CAR_FORM_STATUS_NOT_SENT.code) {
          if (!this.actionDialog.departureDate) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_VehicleTime'))
            return
          }
          // “完成时间”不可早于“出车时间”
          if (this.actionDialog.finishedDate < this.actionDialog.departureDate) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CompletionTimeNotEarlierThanDispatchTime'))
            return
          }
        } else {
          // “完成时间”不可早于“出车时间”
          const row = this.selectedRows.find(p => p.departureDate > this.actionDialog.finishedDate)
          if (row) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CompletionTimeNotEarlierThanDispatchTime'))
            return
          }
        }
      }
      if (this.actionDialog.departureDate && this.actionDialog.finishedDate &&
        this.actionDialog.finishedDate < this.actionDialog.departureDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CompletionTimeNotEarlierThanDispatchTime'))
        return
      }
      this.loading = getLoading4Cxt()
      editCarFormStatus(this.actionDialog).then(res => {
        this.actionDialog.visible = false
        this.queryHandler()
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      }).finally(() => {
        this.loading.close()
      })
    },
    // show 操作弹窗
    showActionDialog(action) {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      this.actionDialog = {
        visible: false,
        action: action,
        status: null,
        departureDate: null,
        finishedDate: null,
        carFormUuids: this.selectedRows.map(p => p.uuid)
      }
      if (action === SystemConstants.CAR_FORM_ACTION_SENT.code) {
        const row = this.selectedRows.find(p => p.status !== SystemConstants.CAR_FORM_STATUS_NOT_SENT.code)
        if (row) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectNotDispatched'))
          return
        }
      } else if (action === SystemConstants.CAR_FORM_ACTION_REVOKE_SENT.code) {
        const row = this.selectedRows.find(p => p.status !== SystemConstants.CAR_FORM_STATUS_SENT.code)
        if (row) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectDispatched'))
          return
        }
        this.actionDialog.status = SystemConstants.CAR_FORM_STATUS_NOT_SENT.code
      } else if (action === SystemConstants.CAR_FORM_ACTION_FINISHED.code) {
        const status = this.selectedRows[0].status
        const row = this.selectedRows.find(p => p.status !== status)
        if (row) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectStatusConsistent'))
          return
        }
        if (status === SystemConstants.CAR_FORM_STATUS_FINISHED.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_VehicleOrderCompleted'))
          return
        }
      } else if (action === SystemConstants.CAR_FORM_ACTION_REVOKE_FINISHED.code) {
        const row = this.selectedRows.find(p => p.status !== SystemConstants.CAR_FORM_STATUS_FINISHED.code)
        if (row) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectCompleted'))
          return
        }
        this.actionDialog.status = SystemConstants.CAR_FORM_STATUS_SENT.code
      }
      this.actionDialog.visible = true
    },
    // 取消车单
    async cancelCarForm() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      if (this.selectedRows.length > 1) {
        this.$message.warning(this.$t('Clearing.PleaseSelectOnlyOneRecord'))
        return
      }
      if (this.selectedRows[0].status !== SystemConstants.CAR_FORM_STATUS_NOT_SENT.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CancelCondition'))
        return
      }
      const flag = await this.$confirm(this.$t('CargoMsg.Cargo_ConfirmCancelVehicleOrder'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => true).catch(() => false)
      if (!flag) {
        return
      }
      this.loading = getLoading4Cxt()
      cancelCarForm({ uuid: this.selectedRows[0].uuid }).then(res => {
        this.queryHandler()
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      }).finally(() => {
        this.loading.close()
      })
    },
    onRowDoubleClickedHandler(event) {
      this.selectedRow = event.data
      this.detail()
    },
    onRowClickedHandler(event) {
      this.selectedRow = event.data
    },
    setSelectValue(obj) {
      this.airlineProductDialog.form[obj.key] = obj.value
    },
    // 分页触发查询
    fetchDataByPage() {
      this.queryHandler(this.filter.conditions)
    },
    queryHandler(data) {
      if (data) {
        this.filter.conditions = data
      }
      this.loading = getLoading4Cxt()
      this.filter.branchId = this.$store.getters.currentOfficeId
      queryCarForm(this.filter).then(res => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.filter.total = Number(res.data.total)
        this.selectedRow = null
        this.selectedRows = []
      }).finally(() => {
        this.loading.close()
      })
    },
    detail() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      this.view = 'detail'
      this.$nextTick(() => {
        this.$refs.carFormTabDetail.init(this.selectedRow.uuid)
      })
    },
    edit() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      this.view = 'detail'
      this.$nextTick(() => {
        this.$refs.carFormTabDetail.init(this.selectedRow.uuid)
        this.$refs.carFormTabDetail.isEdit = true
      })
    },
    back() {
      this.view = 'list'
      this.queryHandler()
    }
  }
}
</script>

<style scoped lang="scss">
.input-label {
  display: inline-block;
  width: 60px;
  color: #666666;
}
.el-form{
  /deep/ .el-input__inner{
    width: 300px;
  }
}
</style>
